
    <p-messages *ngIf="companyRequireClosedError" severity="error">
        <ng-template pTemplate>
            La compañia no permite facturar expedientes sin finalizar
        </ng-template>
    </p-messages> 
    <p-messages *ngIf="transaction.target=='Company' && !this.case?.contract?.allowPartialBill" severity="warn">
        <ng-template pTemplate>
            La compañia no permite facturar parcialmente
        </ng-template>
    </p-messages>
    <p-messages *ngIf="jobsNotBillable?.length > 0" severity="warn">
        <ng-template pTemplate>
            Hay trabajos a compañía que no están marcados para facturar, por lo que no aparecen en la lista de trabajos a facturar.
        </ng-template>
    </p-messages>    
    <p-messages *ngIf="jobsNotCaseServiceValidated?.length > 0" severity="warn">
        <ng-template pTemplate>
            Hay trabajos a compañía que tienen la visita no validada, por lo que no aparecen en la lista de trabajos a facturar.
        </ng-template>
    </p-messages>    
    <p-messages *ngIf="pendingServices?.length > 0" severity="warn">
        <ng-template pTemplate>
            El expediente tiene citas sin finalizar.
        </ng-template>
    </p-messages>  

    <div *ngIf="!companyRequireClosedError">

        <div class="grid">
            <div class="col-3 input-field">
                <label for="name">Destinatario</label>
                <p-dropdown name="icon" [options]="targets" optionLabel="name" optionValue="id"
                [filter]="true" filterBy="name" placeholder="Seleccione" appendTo="body"
                [(ngModel)]="transaction.target" (onChange)="targetSelected()" d-form-field-error />
            </div>   
            <div class="col-9 input-field" *ngIf="transaction.target == 'ThirdParty'">
                <label for="thirdPartyId">Implicado *</label>
                <p-dropdown [(ngModel)]="transaction.thirdPartyId" [options]="affecteds" optionValue="id" optionLabel="name" appendTo="body"
                    placeholder="Selecciona un implicado" showClear [filter]="true" d-form-field-error>
                </p-dropdown>
            </div>         
            <div class="col-3 input-field">
                <label for="name">Modo de facturación</label>
                <p-dropdown name="icon" [options]="filteredInvoiceModes" optionLabel="name" optionValue="id"
                [filter]="true" filterBy="name" placeholder="Seleccione" appendTo="body" (onChange)="loadTransactionSeries()"
                [(ngModel)]="transaction.invoiceMode" d-form-field-error />
            </div>
            <div class="col-3 input-field">
                <label for="name">Serie</label>
                <p-dropdown name="transactionSerieId" [options]="transactionSeries" optionLabel="name" optionValue="id"
                [filter]="true" filterBy="name" placeholder="Seleccione serie" appendTo="body"          
                [(ngModel)]="transaction.transactionSerieId" d-form-field-error/>
            </div>            
            <div class="col-3 input-field">
                <label for="date">Fecha</label>
                <p-calendar [firstDayOfWeek]="1" [(ngModel)]="transaction.date" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" [disabled]="true" d-form-field-error></p-calendar>
            </div>
            <div class="col-12 input-field" *ngIf="caseNotificationNumbers.length>0">
                <label for="name">Servicio</label>
                <p-dropdown name="caseNotificationNumber" [options]="caseNotificationNumbers"
                    [filter]="true" filterBy="name" placeholder="Seleccione servicio" appendTo="body"          
                    [(ngModel)]="selectedCaseNotificationNumber" (onChange)="onCaseNotificationNumberSelected()" d-form-field-error>
                    <ng-template pTemplate="selectedItem"  let-notificationNumber>
                        <div class="flex flex-column" *ngIf="transaction.caseNotificationNumberId">
                            <div>{{notificationNumber?.code}} - {{notificationNumber?.date | date: 'dd/MM/yyyy'}}</div>
                            <small>{{notificationNumber?.capabilityDescription}} - {{notificationNumber?.description}}</small>
                        </div>
                    </ng-template>
                    <ng-template let-notificationNumber pTemplate="item">
                        <div class="flex flex-column">
                            <div>{{notificationNumber?.code}} - {{notificationNumber?.date | date: 'dd/MM/yyyy'}}</div>
                            <small>{{notificationNumber?.capabilityDescription}} - {{notificationNumber?.description}}</small>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>  
        </div> 
        <!--<div class="grid" *ngIf="transactionTypeInvoice.enableGeneralDescription">
            <div class="col-12  input-field">
                <label for="description">Notas</label><small>Esta información se verá en el documento</small>
                <textarea pInputTextarea rows="3" d-form-field-error [(ngModel)]="transaction.description"></textarea>
            </div>
        </div>  -->
        <p-table styleClass="m-1 mt-4" #grid [value]="jobs" [loading]="loading"            
            [scrollable]="true" scrollHeight="flex"
            [(selection)]="selectedLines"
            dataKey="id" 
            >
            <ng-template pTemplate="header" let-columns>
                <tr> 
                    <th style="width: 4rem"><p-tableHeaderCheckbox  [disabled]="!this.case?.contract?.allowPartialBill" /></th>           
                    <th width="80">Fecha</th>
                    <th>Especialidad</th>
                    <th>Baremo</th>
                    <th>Revisado</th>                                        
                    <th style="text-align: right;">Cantidad</th>
                    <th style="text-align: right;">Precio</th>
                    <th style="text-align: right;">Impuestos</th>
                    <th style="text-align: right;">Total</th>                                     
                </tr>
            </ng-template> 
            <ng-template pTemplate="body" let-job let-i="rowIndex" let-columns="columns" let-index="rowIndex">
                <tr>
                    <td>
                        <p-tableCheckbox 
                            [value]="job" [disabled]="!this.case?.contract?.allowPartialBill"></p-tableCheckbox>
                    </td>
                    <td>{{ job.date | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ job.rateLine?.capability?.name }}</td>
                    <td> 
                        {{ job.code }} - {{ job.rateLineDescription }}
                        <small *ngIf="job.description"><br>{{ job.description | slice: 0:50 }}</small>
                    </td>
                    <td>
                        <i class="pi" [ngClass]="{
                                    'text-green-500 pi-check-circle': job.isReview,
                                    'text-red-500 pi-times-circle': !job.isReview
                                }"></i>
                    </td>                                                          
                    <td style="text-align: right;">{{ job.quantity }}</td>
                    <td style="text-align: right;">
                        {{ job.unitPrice | currency: 'EUR' }}
                        <small *ngIf="transaction.target === 'Company' && job.jobGuardCompanyIncrementPercent != null"><br>Guardia  {{  job.jobGuardCompanyIncrementPercent != null ? job.jobGuardCompanyIncrementPercent + '%' : 0 + '%)' }}</small>
                    </td>
                    <td style="text-align: right;">
                        {{ '(' + (job.taxPercent != null ? job.taxPercent : 0) + '%) ' }}
                        {{ job.taxAmount | currency: 'EUR' }}
                    </td>
                    <td style="text-align: right;">{{ job.total | currency: 'EUR' }}</td>
                </tr>
            </ng-template>            
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td style="text-align: center;" colspan="9">
                        No se han encontrado líneas.
                    </td>
                </tr>
            </ng-template>
        </p-table>   
        <div class="flex justify-between">
            <div class="col-8">
                <div class="grid">
                    <!-- no activar porque no sabriamos como repartirlo con varios ivas-->
                    <!--<div class="col-4 input-field">
                        <label for="invoiceDiscount">Descuento a aplicar en factura</label>
                        <p-inputNumber name="invoiceDiscount" [(ngModel)]="transaction.invoiceDiscount" [min]="0" [max]="100" suffix="%"
                        d-form-field-error />
                    </div>-->
                    <div class="col-3 input-field" *ngIf="transaction.invoiceMode == 'invoice'">
                        <label for="name">Forma de pago</label>
                        <p-dropdown name="paymentMethodId" [options]="paymentsMethods" optionLabel="name" optionValue="id"
                          [filter]="true" filterBy="name" placeholder="Seleccione forma de pago" appendTo="body"
                          (onChange)="onPaymentMethodChange($event.value)" 
                          [(ngModel)]="transaction.paymentMethodId" d-form-field-error />
                    </div> 
                    <div class="col-3 input-field" *ngIf="transaction.invoiceMode == 'invoice'">
                        <label for="date">Fecha de vencimiento</label>
                        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="transaction.paymentDuedate" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                            [yearNavigator]="true" dateFormat="dd/mm/yy"  d-form-field-error></p-calendar>
                    </div>
                    <div class="col-6 input-field" *ngIf="selectedPaymentMethodRequiresBank && transaction.invoiceMode == 'invoice'">
                        <label for="name">Cuenta bancaria</label>
                        <p-dropdown name="billingCompanyBankAccountId" [options]="billingCompaniesBanksAccounts"
                          optionLabel="accountNumber" optionValue="id" [filter]="true" filterBy="accountNumber" [(ngModel)]="transaction.billingCompanyBankAccountId"
                          placeholder="Seleccione cuenta bancaria" appendTo="body" 
                          d-form-field-error />
                    </div>
                </div>
                <div class="grid">
                    <div class="col-4 input-field" *ngIf="transaction.target == 'Company'">
                        <label for="invoiceRetentionPercent">Retención de obra</label>
                        <p-inputNumber name="invoiceRetentionPercent" [(ngModel)]="transaction.invoiceRetentionPercent" [min]="0" [max]="100" suffix="%"
                        d-form-field-error />
                    </div>
                    <div class="col-4 input-field" *ngIf="transaction.target == 'Company'">
                        <label for="invoiceRetentionDays">Días de rentención</label>
                        <p-inputNumber name="invoiceRetentionDays" [(ngModel)]="transaction.invoiceRetentionDays" [min]="0" [max]="100"
                        d-form-field-error />
                    </div>
                </div>
                <div class="grid">
                    <div class="col-12 input-field" *ngIf="transactionTypeInvoice.enableGeneralDescription">
                        <label for="description">Notas</label><small class="text-danger">Esta información se verá en el documento</small>
                        <textarea pInputTextarea rows="5" d-form-field-error [(ngModel)]="transaction.notes"></textarea>                                        
                    </div>
                </div>
            </div>
            <div class="col-4 flex gap-2 justify-content-end">
                <div style="text-align: right;">
                    <h3><b>Subtotal:</b> {{ getSubtotalSelected() | currency: 'EUR':'symbol':'1.2-2' }}</h3>
                    <h3 *ngIf="transaction.invoiceDiscount > 0">
                        <b>Descuento ({{ transaction.invoiceDiscount }}%):</b> 
                        {{ getDiscountAmount() | currency: 'EUR':'symbol':'1.2-2' }}
                    </h3>
                    <h3 *ngIf="transaction.invoiceRetentionPercent > 0 && transaction.target == 'Company'">
                        <b>Retención de obra ({{ transaction.invoiceRetentionPercent }}%):</b> 
                        {{ getRetentionAmount() | currency: 'EUR':'symbol':'1.2-2' }}
                    </h3>
                    <h3><b>Impuestos:</b> {{ getAmountSelected() | currency: 'EUR':'symbol':'1.2-2' }}</h3>
                    <!--<h3><b>Impuestos:</b> {{ getTaxSelected() | currency: 'EUR' }}</h3>-->
                    <h2><b>Total:</b> {{ getTotalSelected() | currency: 'EUR':'symbol':'1.2-2' }}</h2>
                    <h3 *ngIf="getAdvancedAmountSelected() > 0"><b>Anticipos:</b> {{ getAdvancedAmountSelected() | currency: 'EUR':'symbol':'1.2-2' }}</h3>
                </div>
            </div> 
        </div>
    </div>

    <div class=" mt-4 flex gap-2 justify-content-end" style="align-items: center;">
        <div class="flex-grow-1"></div>
        <label class="inline-flex align-items-center gap-2 cursor-pointer" *ngIf="canSendToCompany"><p-checkbox name="sendToCompany" [(ngModel)]="sendToCompany" [binary]="true" />Enviar a compañía</label>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button *ngIf="!companyRequireClosedError && allowWrite" label="Facturar" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>

<p-confirmDialog></p-confirmDialog>